/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingMetricListRequest {
    getFixupPrototypeFunction() { return BillingMetricListRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingMetricListRequest>): BillingMetricListRequest {
        let obj = Object.assign(new BillingMetricListRequest(), model);
        BillingMetricListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingMetricListRequest>): BillingMetricListRequest {
        if (!model) return null;
        return BillingMetricListRequest.newInstance(<BillingMetricListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingMetricListRequest) {
        if (!obj) return;

        models.BillingMetricListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingMetricListRequest): boolean {
        Object.setPrototypeOf(obj, BillingMetricListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.BillingMetricFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Filters for the Billing Metrics
     */
    filters: models.BillingMetricFilters;

}
